/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../../../../../../../../_metronic/_helpers';
import AddIcon from "@material-ui/icons/Add";

const status = ["REQUEST_VOID", "VOID", "SETTLE"]
const access = ['CustomerCare', 'DataProses', 'Fundraiser', 'FundCollCheck', 'KepalaCabang', 'SuperAdmin']
export const ActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    { openDetailDonationPage, openDialogVoid, role, Link, addDonationToReconcile },
) => {
    return (
      <div className="text-center">
        <OverlayTrigger
          overlay={<Tooltip id="donation-edit-tooltip">View Detail</Tooltip>}
        >
          <Link
            to={`/donasi/${row.donation && row.donation.uuid}/detail`}
            className="text-light"
          >
            <a className="btn btn-icon btn-light btn-hover-info btn-sm mx-3">
              <span className="svg-icon svg-icon-md svg-icon-info">
                <i className="fa fa-eye"></i>
                {/* <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                /> */}
              </span>
            </a>
          </Link>
        </OverlayTrigger>
        <OverlayTrigger
          overlay={<Tooltip id="donation-edit-tooltip">Tambah</Tooltip>}
        >
          <a className="btn btn-icon btn-light btn-hover-success btn-sm mx-3">
            <span className="svg-icon svg-icon-md svg-icon-success">
                <AddIcon/>
            </span>
          </a>
        </OverlayTrigger>
      </div>
    );
}
